import type { ReactNode } from 'react';
import { C2Shape } from '../c2';
import type { PastelColor } from '../c2/Pill';

export interface DecorShape {
  shape: 'circle' | 'pill' | 'square';
  size: number;
  color: PastelColor;
  style?: React.CSSProperties;
}

interface PageHeroProps {
  title: string;
  titleAccentWord?: string;
  sub?: string;
  decorShapes: DecorShape[];
  titleMaxWidth?: number;
}

function renderTitle(title: string, accentWord?: string): ReactNode {
  if (!accentWord || !title.includes(accentWord)) return title;
  const i = title.indexOf(accentWord);
  return (
    <>
      {title.slice(0, i)}
      <span style={{ color: 'var(--accent-solid)' }}>{accentWord}</span>
      {title.slice(i + accentWord.length)}
    </>
  );
}

export default function PageHero({ title, titleAccentWord, sub, decorShapes, titleMaxWidth }: PageHeroProps) {
  return (
    <section
      className="relative overflow-hidden"
      style={{ padding: `92px clamp(32px, 6vw, 96px) ${sub ? 56 : 24}px` }}
    >
      {decorShapes.map((s, i) => (
        <C2Shape key={i} shape={s.shape} size={s.size} color={s.color} style={s.style} />
      ))}
      <div
        className="mx-auto text-center relative"
        style={{ maxWidth: titleMaxWidth ?? 720 }}
      >
        <h1
          className={`font-display font-extrabold text-ink m-0 ${sub ? 'mb-7' : ''}`}
          style={{ fontSize: 'clamp(28px, 3.6vw, 62px)', lineHeight: 0.92, letterSpacing: '-0.045em' }}
        >
          {renderTitle(title, titleAccentWord)}
        </h1>
        {sub && (
          <p className="text-[19px] text-ink-soft leading-[1.55] max-w-[620px] mx-auto m-0">
            {sub}
          </p>
        )}
      </div>
    </section>
  );
}
